import { useLocation, useNavigation } from "@remix-run/react";

type GlobalLoadingProps = {
  children: React.ReactNode;
  excludePaths?: string[];
};

export function GlobalLoading({ children, excludePaths }: GlobalLoadingProps) {
  const navigation = useNavigation();
  const location = useLocation();
  const isNavigating = navigation.state !== "idle";
  const isExcluded = excludePaths?.some((path) =>
    location.pathname.includes(path),
  );

  if (!isNavigating) return children;
  if (isExcluded) return children;

  return (
    <div className="bg-opacity-70 flex min-h-screen w-full items-center justify-center bg-white">
      <div className="flex h-[100px] w-[100px] items-center justify-center">
        <div className="border-primary h-[50px] w-[50px] animate-spin rounded-full border-4 border-t-transparent"></div>
      </div>
    </div>
  );
}
